import React, { createContext, useContext, useRef } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const modalRefs = useRef({});
  const openModalRefs = useRef({});

  const registerModalRef = (key, ref) => {
    if (ref && typeof ref === 'object' && 'current' in ref) {
      modalRefs.current[key] = ref;
    }
  };

  const markModalOpen = (key, ref) => {
    if (ref && typeof ref === 'object' && 'current' in ref) {
      openModalRefs.current[key] = ref;
    }
    return openModalRefs.current;
  };

  const markModalClosed = (key) => {
    delete openModalRefs.current[key];
  };

  const getModalRef = (key) => modalRefs.current[key];

  const closeAllModals = () => {
    Object.values(openModalRefs.current).forEach(
      (ref) => ref?.current?.open && ref.current.onClose()
    );

    return new Promise((resolve) => {
      const start = Date.now();
      const maxWaitMs = 1500;

      (function check() {
        const allClosed = Object.values(openModalRefs.current).every(
          (ref) => !ref?.current?.open
        );

        if (allClosed || Date.now() - start > maxWaitMs) {
          resolve();
        } else {
          setTimeout(check, 16); // ~1 frame
        }
      })();
    });
  };

  return (
    <ModalContext.Provider
      value={{
        registerModalRef,
        getModalRef,
        closeAllModals,
        markModalOpen,
        markModalClosed,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => useContext(ModalContext);
